import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { Sendable, SendCartableFormViewModel, SendPackage, SendPackageStateEnumProvider } from "./sendCartableForm-viewModel"

export class SendCartableFormView extends View<SendCartableFormViewModel>{
    GetViewUniqueId(): string {
        return "V-E89139C2-930F-4E39-ABF3-9977D2DF9E3C"
    }
    loadHtml(): string {
        let element = require('./sendCartableForm.html').default;
        let style = require('./sendCartableForm.less');
        return element;
    }
    constructor() {
       super();
    }
    public set sendables(v: ObservableArray<Sendable>) { this._sendables = v; } public get sendables(): ObservableArray<Sendable> { return this._sendables;} private _sendables: ObservableArray<Sendable>;
    public set sendPackageStateEnumProvider(v: SendPackageStateEnumProvider) { this._sendPackageStateEnumProvider = v; } public get sendPackageStateEnumProvider(): SendPackageStateEnumProvider { return this._sendPackageStateEnumProvider;} private _sendPackageStateEnumProvider: SendPackageStateEnumProvider;
    public set sendPackages(v: ObservableArray<SendPackage>) { this._sendPackages = v; } public get sendPackages(): ObservableArray<SendPackage> { return this._sendPackages;} private _sendPackages: ObservableArray<SendPackage>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isLoadingSendable(v: boolean) { this._isLoadingSendable = v; } public get isLoadingSendable(): boolean { return this._isLoadingSendable;} private _isLoadingSendable: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    public set selectAll(v: boolean) { this._selectAll = v; } public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;

    cancelSelected() {
        this.dataContext.cancelSelected();
    }

    createPackage() {
        this.dataContext.createPackage();
    }

    printSelectedSendables(){
        this.dataContext.printSelectedSendables();
    }
}
